module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "p2222"
  }, [_c('pay-password', {
    ref: "p",
    attrs: {
      "number": _vm.number
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p2222"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg btn-block",
    on: {
      "click": _vm.clean
    }
  }, [_vm._v("重 置")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bfc14b90!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pay-password/demo.vue
// module id = 279
// module chunks = 28